import { createAction } from 'redux-actions';

import { createAlertAction } from 'store/alerts';

import {
  UPDATE_DIAGNOSES,
  UPDATE_DIAGNOSIS,
  RESET_DIAGNOSES,
  UPDATE_DIAGNOSIS_REPORTS,
  UPDATE_DIAGNOSIS_REPORT,
  RESET_DIAGNOSIS_REPORTS,
  UPDATE_DIAGNOSIS_CODES,
  FETCH_DIAGNOSIS_CODES,
  FETCH_DIAGNOSES,
  FETCH_DIAGNOSES_FOR_EXAMINATION,
  FETCH_DIAGNOSIS_REPORTS,
  SAVE_DIAGNOSIS,
  CREATE_DIAGNOSIS_PREVIEW_REPORT,
  WITHDRAW_DIAGNOSIS,
  TAKE_OVER_DIAGNOSIS,
  LOAD_ANALYSIS_IMAGES,
} from './types';

export const updateDiagnoses = createAction(UPDATE_DIAGNOSES);
export const updateDiagnosis = createAction(UPDATE_DIAGNOSIS);
export const resetDiagnoses = createAction(RESET_DIAGNOSES);

export const updateDiagnosisReports = createAction(UPDATE_DIAGNOSIS_REPORTS);
export const updateDiagnosisReport = createAction(UPDATE_DIAGNOSIS_REPORT);
export const resetDiagnosisReports = createAction(RESET_DIAGNOSIS_REPORTS);

export const updateDiagnosisCodes = createAction(UPDATE_DIAGNOSIS_CODES);

export const fetchDiagnosisCodes = createAlertAction(FETCH_DIAGNOSIS_CODES);
export const fetchDiagnoses = createAlertAction(FETCH_DIAGNOSES);
export const fetchDiagnosesForExamination = createAlertAction(FETCH_DIAGNOSES_FOR_EXAMINATION);
export const fetchDiagnosisReports = createAlertAction(FETCH_DIAGNOSIS_REPORTS);
export const saveDiagnosis = createAlertAction(SAVE_DIAGNOSIS);
export const createDiagnosisPreviewReport = createAlertAction(CREATE_DIAGNOSIS_PREVIEW_REPORT);
export const withdrawDiagnosis = createAlertAction(WITHDRAW_DIAGNOSIS);
export const takeOverDiagnosis = createAlertAction(TAKE_OVER_DIAGNOSIS);
export const loadAnalysisImages = createAlertAction(LOAD_ANALYSIS_IMAGES);
